/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import decryptJWT from '../../../utils/decryptJWT';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';
export default function SelectMultiOperadora(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const [lsOperadora, setLsOperadora] = useState([])
    const modal = useRef();
    let todasOperadoras = []

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleOperadora(codigo, checkbox){
        if(codigo == -1){
            handleSelecionarTodos(checkbox)
        }else{
            if(checkbox === true){
                        props.arrayOperadora.push(codigo)
            }else{
                props.arrayOperadora.forEach(function(e, index){
                    if(codigo == e){
                        props.arrayOperadora.splice(index, 1);
                    }
                })
            }   
        }
    }

    function handleSelecionarTodos(checked){
        const length = props.arrayOperadora.length
        let i =0
        while(i < length){
            props.arrayOperadora.pop()
            i++
        }
  
        if(checked === true){
            todasOperadoras.forEach(function(usuario){
                props.arrayOperadora.push(usuario.cd_dsp_operadora)
            })
        }
    }

    function handleCancelar(){
        props.setRevelarSelectMultiOperadora(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderOperadora(){
            const {data} = await api_gateway.get('/m1/consultar/fat_operadora?cd_pav_usuario='+decryptJWT('codigo'));
            data.dados.unshift({"cd_dsp_operadora":-1,"ds_apelido":"Todos"})
            todasOperadoras=data.dados
            
            if(data.dados.length > 0){
                let objetoOperadora = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.cd_dsp_operadora}>
                            <div className="campo-select-opcao-checkbox campo-select-opcao-2 campo-select-opcao-automacao">
                                <label className="container-checkbox-item-select">
                                    <input id={item.cd_dsp_operadora} type="checkbox" defaultChecked={handleMarcarCheckboxes(item.cd_dsp_operadora) ? true : false} onChange={e => handleOperadora(item.cd_dsp_operadora, e.target.checked)}/>
                                    <span className="chekmark-checkbox-item-select" />
                                </label>
                                <span className="fonte-cor-1 nao-selecionavel">{item.ds_apelido}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsOperadora(objetoOperadora)
            }else{
                let objetoOperadora = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsOperadora(objetoOperadora)
            }
            setSpinAtivo(false)
        }
        renderOperadora()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);
    }, [])

    function handleMarcarCheckboxes(codigo){
        let verificacao = false
        
        props.arrayOperadora.forEach(function(e){
            
            if(codigo === e){
                verificacao = true
            }
        })
        return verificacao
    }

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }  
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select campo-select-absoluto" onClick={() => handleCancelar()}>
                <div className="fonte-cor-1 label-campo">{props.dsOperadoras}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo triangulo-select-absoluto" />
            <div className="campo-texto-cor-3 campo-select-usuarios-checkbox-corpo">
                <ul className="campo-select-lista">
                    {lsOperadora}
                </ul>
            </div>
        </Form>
    )
}